import propTypes from "prop-types"
import Swal from 'sweetalert2'
import '../views/formations-page.css'
import './cpf-modal.css'

const FormationText = (props) => {
	function afficherModalitesCPF() {
		Swal.fire({
			title: "Modalités d'inscription CPF",
			html: `
				<ol class="cpf-modal-steps">
					<li><span class="cpf-modal-step-number">1</span><span class="cpf-modal-step-text">Connectez-vous sur <a href="https://www.moncompteformation.gouv.fr" target="_blank" rel="noreferrer">moncompteformation.gouv.fr</a> via France Connect.</span></li>
					<li><span class="cpf-modal-step-number">2</span><span class="cpf-modal-step-text">Recherchez la formation souhaitée à l'aide du lien "Demander un devis via mon CPF" disponible sur la page de la formation, ou en recherchant IperBTP / le numéro RS de la formation.</span></li>
					<li><span class="cpf-modal-step-number">3</span><span class="cpf-modal-step-text">Vérifiez votre solde CPF disponible et complétez, si besoin, avec un autre mode de financement (OPCO, France Travail, financement personnel...).</span></li>
					<li><span class="cpf-modal-step-number">4</span><span class="cpf-modal-step-text">Validez votre demande d'inscription en ligne.</span></li>
					<li><span class="cpf-modal-step-number">5</span><span class="cpf-modal-step-text">IperBTP reçoit votre demande et vous confirme votre inscription ainsi que les dates de session.</span></li>
				</ol>
				<p class="cpf-modal-note">Pour toute question sur votre dossier, contactez-nous directement.</p>
			`,
			showCloseButton: true,
			showConfirmButton: true,
			confirmButtonText: "Compris",
			buttonsStyling: false,
			customClass: {
				popup: 'cpf-modal-popup',
				title: 'cpf-modal-title',
				confirmButton: 'btn btn-download cpf-modal-confirm'
			}
		})
	}

	return (
		<div className="text-div">
			<div className="hide-mobile">
				<h5 className="mb-3">Taux de satisfaction global : {props.tauxSatisfaction} % </h5>
					{(props.nomFormation === "CSPS" || props.nomFormation === "SS3" || props.nomFormation === "SS4") &&
						<div className="mb-3">
							<h5 className="mb-2">Formation éligible au CPF / France Travail</h5>
							<button onClick={afficherModalitesCPF} className="btn btn-download">Modalités d'inscription CPF</button>
						</div>
					}
				<h4>Objectifs de la formation</h4>
				<span className="home-text14">
					<span>
						{props.objectif}
					</span>
					<br />
					<br />
					{props.isDiagnostiqueur && <span>
						<h4 className="d-flex justify-content-start text-black">Evaluation / Validation</h4>
						<ul>
							<li>Examens écrits</li>
							<li>Examens oraux</li>
							<li>Rédaction de rapports de diagnostic</li>
							<li>L‘assiduité donne droit à la délivrance de l’attestation de formation</li>
							<li>Titre de diagnostiqueur technique immobilier niveau V (Bac+2) (pour le cycle 2)</li>
						</ul>
						<h4 className="d-flex justify-content-start text-black">Pédagogie</h4>
						<ul>
							<li>Diaporama pédagogique interactif</li>
							<li>Photothèque</li>
							<li>Livret stagiaire</li>
							<li>Matériel</li>
							<li>Exercices d’entraînement / QCM d’entraînement</li>
						</ul>
					</span>}
					{!props.isDiagnostiqueur && <span>
						<span className="d-flex justify-content-start">Moyens pédagogiques :</span>
						<ul>
							<li>Salle de cours pouvant accueillir 10 participants</li>
							<li>Salle de pause</li>
							<li>Supports de cours remis aux participants</li>
							<li>Exercices pratiques</li>
							<li>Vidéoprojecteur</li>
						</ul>
					</span>}
					{props.showEvalPeda && <div><span>
						<span className="d-flex justify-content-start">Pédagogie :</span>
						<ul>
							<li> Alternance d’enseignement théorique, de mises en situation des stagiaires, d’études de cas et d’exercices pratiques </li>
						</ul>
					</span>
						<span>
							<span className="d-flex justify-content-start">Evaluation :</span>
							<ul>
								<li> La délivrance de l'attestation de compétence est effectué à l'issue de la réussite de l'évaluation des connaissances : théorique et pratique</li>
							</ul>
						</span></div>}
				</span>
			</div>
		</div>
	)
}

export default FormationText

FormationText.defaultProps = {
	objectif: 'Description des objectifs',
	downloadLink: "RE.pdf",
	nomFormation: "",
	showEvalPeda: true,
	isDiagnostiqueur: false,
	tauxSatisfaction: "N/A"
}

FormationText.propTypes = {
	objectif: propTypes.string,
	downloadLink: propTypes.string,
	nomFormation: propTypes.string,
	isDiagnostiqueur: propTypes.bool,
	showEvalPeda: propTypes.bool,
	tauxSatisfaction: propTypes.string
}

// Nouveaux props pour les informations d'enregistrement
FormationText.defaultProps = Object.assign({}, FormationText.defaultProps, {
	numeroRS: '',
	eligibleCPF: false,
	dateDebutParcours: '',
	dateEcheanceEnregistrement: '',
	lienFranceCompetences: '',
	arrete: '',
	certificateur: ''
})

FormationText.propTypes = Object.assign({}, FormationText.propTypes, {
	numeroRS: propTypes.string,
	eligibleCPF: propTypes.oneOfType([propTypes.bool, propTypes.string]),
	dateDebutParcours: propTypes.string,
	dateEcheanceEnregistrement: propTypes.string,
	lienFranceCompetences: propTypes.string,
	arrete: propTypes.string,
	certificateur: propTypes.string
})
